/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */
import { createAction } from '../../../../../modules/app/createAction';
import {
    CLEAR_FILTER,
    CLEAR_FILTER_FAILED,
    CLEAR_FILTER_SUCCESSFUL,
    DELETE_EXTFILTER,
    DELETE_EXTFILTER_FAILED,
    DELETE_EXTFILTER_SUCCESSFUL,
    LOAD_EXTFILTER,
    LOAD_EXTFILTER_FAILED,
    LOAD_EXTFILTER_SUCCESSFUL,
    SAVE_EXTFILTER,
    SAVE_EXTFILTER_FAILED,
    SAVE_EXTFILTER_SUCCESSFUL,
    SEND_EXTFILTER,
    SEND_EXTFILTER_FAILED,
    SEND_EXTFILTER_SUCCESSFUL,
    SET_EXTFILTER_TAB_INDEX,
    UPDATE_EXTFILTER,
    UPDATE_EXTFILTER_FAILED,
    UPDATE_EXTFILTER_SUCCESSFUL,
} from '../constants/extFilterApiConstants';
import {
    ISaveExtFilterPayload,
    ISendExtFilterPayload,
    TClearFilterAction,
    TClearFilterFailedAction,
    TClearFilterSuccessfulAction,
    TDeleteExtFilterAction,
    TDeleteExtFilterFailedAction,
    TDeleteExtFilterSuccessfulAction,
    TLoadExtFilterAction,
    TLoadExtFilterFailedAction,
    TLoadExtFilterSuccessfulAction,
    TSaveExtFilterAction,
    TSaveExtFilterFailedAction,
    TSaveExtFilterSuccessfulAction,
    TSendExtFilterAction,
    TSendExtFilterFailedAction,
    TSendExtFilterSuccessfulAction,
    TSetExtFilterTabIndexAction,
    TUpdateExtFilterAction,
    TUpdateExtFilterFailedAction,
    TUpdateExtFilterSuccessfulAction,
} from '../types/extFilterActionTypes';
import { IExtFilterData, ISubscriberMobileExtFilter } from '../types/extFilterTypes';

/*
* -------------------------------------------
*           SET TAB INDEX
* -------------------------------------------
*/

export const setExtFilterTabIndex = (payload?: number): TSetExtFilterTabIndexAction =>
    createAction(SET_EXTFILTER_TAB_INDEX, payload);


/*
* -------------------------------------------
*           LOAD CURRENT SETTINGS
* -------------------------------------------
*/

export const loadExtFilter = (): TLoadExtFilterAction =>
    createAction(LOAD_EXTFILTER);
export const loadExtFilterSuccessful = (payload: IExtFilterData): TLoadExtFilterSuccessfulAction =>
    createAction(LOAD_EXTFILTER_SUCCESSFUL, payload);
export const loadExtFilterFailed = (message: string): TLoadExtFilterFailedAction =>
    createAction(LOAD_EXTFILTER_FAILED, message);


/*
* -------------------------------------------
*           SEND NEW SETTINGS
* -------------------------------------------
*/

export const sendExtFilter = (payload: ISendExtFilterPayload): TSendExtFilterAction =>
    createAction(SEND_EXTFILTER, payload);
export const sendExtFilterSuccessful = (payload: ISendExtFilterPayload): TSendExtFilterSuccessfulAction =>
    createAction(SEND_EXTFILTER_SUCCESSFUL, payload);
export const sendExtFilterFailed = (message: string): TSendExtFilterFailedAction =>
    createAction(SEND_EXTFILTER_FAILED, message);


/*
* -------------------------------------------
*           SAVE NEW SETTINGS
* -------------------------------------------
*/

export const saveExtFilter = (payload: ISaveExtFilterPayload): TSaveExtFilterAction =>
    createAction(SAVE_EXTFILTER, payload);
export const saveExtFilterSuccessful = (payload: ISubscriberMobileExtFilter): TSaveExtFilterSuccessfulAction =>
    createAction(SAVE_EXTFILTER_SUCCESSFUL, payload);
export const saveExtFilterFailed = (message: string): TSaveExtFilterFailedAction =>
    createAction(SAVE_EXTFILTER_FAILED, message);


/*
* -------------------------------------------
*           UPDATE SETTINGS
* -------------------------------------------
*/

export const updateExtFilter = (payload: ISendExtFilterPayload): TUpdateExtFilterAction =>
    createAction(UPDATE_EXTFILTER, payload);
export const updateExtFilterSuccessful = (payload: ISubscriberMobileExtFilter[]): TUpdateExtFilterSuccessfulAction =>
    createAction(UPDATE_EXTFILTER_SUCCESSFUL, payload);
export const updateExtFilterFailed = (message: string): TUpdateExtFilterFailedAction =>
    createAction(UPDATE_EXTFILTER_FAILED, message);


/*
* -------------------------------------------
*           DELETE SETTINGS
* -------------------------------------------
*/

export const deleteExtFilter = (payload: string): TDeleteExtFilterAction =>
    createAction(DELETE_EXTFILTER, payload);
export const deleteExtFilterSuccessful = (payload: ISubscriberMobileExtFilter[]): TDeleteExtFilterSuccessfulAction =>
    createAction(DELETE_EXTFILTER_SUCCESSFUL, payload);
export const deleteExtFilterFailed = (message: string): TDeleteExtFilterFailedAction =>
    createAction(DELETE_EXTFILTER_FAILED, message);


/*
* -------------------------------------------
*           CLEAR SETTINGS
* -------------------------------------------
*/

export const clearFilter = (): TClearFilterAction =>
    createAction(CLEAR_FILTER);
export const clearFilterSuccessful = (): TClearFilterSuccessfulAction =>
    createAction(CLEAR_FILTER_SUCCESSFUL);
export const clearFilterFailed = (message: string): TClearFilterFailedAction =>
    createAction(CLEAR_FILTER_FAILED, message);

/**
 * @description Common type for exturnal filter reducer.
 * @type SubscriberExtFilterActionTypes
 */
export type TExtFilterApiAction =
    TClearFilterAction
    | TClearFilterFailedAction
    | TClearFilterSuccessfulAction
    | TDeleteExtFilterAction
    | TDeleteExtFilterFailedAction
    | TDeleteExtFilterSuccessfulAction
    | TLoadExtFilterAction
    | TLoadExtFilterFailedAction
    | TLoadExtFilterSuccessfulAction
    | TSaveExtFilterAction
    | TSaveExtFilterFailedAction
    | TSaveExtFilterSuccessfulAction
    | TSendExtFilterAction
    | TSendExtFilterFailedAction
    | TSendExtFilterSuccessfulAction
    | TSetExtFilterTabIndexAction
    | TUpdateExtFilterAction
    | TUpdateExtFilterFailedAction
    | TUpdateExtFilterSuccessfulAction
    ;
